import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, setBlockTracking as _setBlockTracking, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "card" };
const _hoisted_2 = {
    key: 0,
    class: "px-3 lg:px-4 pt-3 pb-2"
};
const _hoisted_3 = { class: "flex justify-between items-center" };
const _hoisted_4 = { class: "font-semibold" };
const _hoisted_5 = ["aria-label", "title"];
const _hoisted_6 = { class: "my-1 text-muted collapsible-content" };
const _hoisted_7 = { class: "grid grid-cols-2 lg:grid-cols-4 gap-4 px-3 lg:px-4 pb-3 lg:pb-4" };
const _hoisted_8 = { class: "font-normal text-2xl" };
const _hoisted_9 = ["textContent"];
const _hoisted_10 = { class: "text-muted text-sm" };
const _hoisted_11 = ["textContent"];
const _hoisted_12 = ["textContent"];
import { computed, ref } from 'vue';
import { ___, toFixedNumberStrWithFallback } from '@ts/common/language';
import SvgVue from '@ts/components/utils/SvgVue.vue';
import {} from '@ts/common/datasets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CompareLactate',
    props: {
        dataA: { default: undefined },
        dataB: { default: undefined },
        help: { type: Boolean, default: false },
        header: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const showHelp = ref(false);
        const vlamax = computed(() => {
            const value = props.dataA === undefined || props.dataB === undefined ? undefined : -100.0 * (1.0 - props.dataA.vlamax / props.dataB.vlamax);
            return {
                value: value,
                string: toFixedNumberStrWithFallback(value, 1),
                stringA: toFixedNumberStrWithFallback(props.dataA?.vlamax, 2),
                stringB: toFixedNumberStrWithFallback(props.dataB?.vlamax, 2),
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    (__props.header)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(___)({
                                    en: 'Max. Rate of Lactate Production',
                                    de: 'Max. Laktatbildungssrate',
                                })), 1 /* TEXT */),
                                (__props.help)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: _cache[1] || (_cache[1] = ($event) => (showHelp.value = !showHelp.value)),
                                        type: "button",
                                        class: "btn text-gray-350 dark:text-gray-450 hover:text-primary-500",
                                        "aria-label": _unref(___)({ en: 'Toggle help', de: 'Hilfe ein- und ausblenden' }),
                                        title: _unref(___)({ en: 'Help', de: 'Hilfe' })
                                    }, [
                                        _cache[0] || (_setBlockTracking(-1, true),
                                            (_cache[0] = _createVNode(SvgVue, {
                                                class: "w-4 h-4",
                                                icon: "lucide/circle-question-mark"
                                            })).cacheIndex = 0,
                                            _setBlockTracking(1),
                                            _cache[0])
                                    ], 8 /* PROPS */, _hoisted_5))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            (__props.help)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["collapsible", showHelp.value ? 'expanded' : ''])
                                }, [
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(___)({
                                        en: 'The maximum lactate production rate indicates the maximum amount of lactate the body can produce in a given time and serves as a gross criterion of anaerobic performance.',
                                        de: 'Die maximale Laktatbildungsrate gibt an, wieviel Laktat der Körper in einer bestimmten Zeit maximal produzieren kann und dient als Bruttokriterium der anaeroben Leistungsfähigkeit.',
                                    })), 1 /* TEXT */)
                                ], 2 /* CLASS */))
                                : _createCommentVNode("v-if", true)
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                            _cache[5] || (_cache[5] = _createElementVNode("div", null, "VLamax", -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(vlamax.value.string)
                                }, null, 8 /* PROPS */, _hoisted_9),
                                _cache[2] || (_cache[2] = _createTextVNode(" %", -1 /* CACHED */))
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(vlamax.value.stringA)
                                }, null, 8 /* PROPS */, _hoisted_11),
                                _cache[3] || (_cache[3] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(vlamax.value.stringB)
                                }, null, 8 /* PROPS */, _hoisted_12),
                                _cache[4] || (_cache[4] = _createTextVNode(" mmol/l/s", -1 /* CACHED */))
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
